function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Administration_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  className: "Administration_svg__a",
  transform: "translate(22 491)",
  d: "M0 0h24v24H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "Administration_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  className: "Administration_svg__c",
  d: "M2.386 21.88a2.276 2.276 0 01-.055-3.214l9.81-10.148a4.844 4.844 0 01.774-5.707l.79-.818a5.362 5.362 0 016.05-.808.569.569 0 01.173.913L17.37 4.744l1.635 1.58 2.558-2.646a.569.569 0 01.918.141 5.362 5.362 0 01-.602 6.075l-.79.817a4.844 4.844 0 01-5.679.968L5.601 21.827a2.276 2.276 0 01-3.215.054zM18.5 1.94a4.045 4.045 0 00-3.978.843l-.79.817c-1.218 1.26-1.352 2.866-.402 4.778a.569.569 0 01-.1.649L3.15 19.457a1.137 1.137 0 001.635 1.58l10.082-10.43a.569.569 0 01.645-.123c1.942.887 3.543.698 4.761-.563l.79-.817A4.045 4.045 0 0021.77 5.1l-2.342 2.423a.569.569 0 01-.804.014l-2.451-2.37a.569.569 0 01-.014-.803z"
}), /*#__PURE__*/React.createElement("path", {
  className: "Administration_svg__c",
  d: "M4.765 18.594l.825.798-1.197 1.237-.824-.797z"
}));

function SvgAdministration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default SvgAdministration;